import Container from "./components/Container";
import "./css/_global.css";

function App() {
  return <><Container /></>;
}

export default App;
